<div
  class="selected-items-template"
  tooltipPosition="bottom"
  positionTop="5"
  positionLeft="20"
  [pTooltip]="tooltipContent"
  [fitContent]="true"
  [autoHide]="false"
>
  <!-- TODO: Dynamic field length calculation -->
  <ng-container [ngTemplateOutlet]="$items().length ? selectedItemsTemplate : placeholderTemplate"></ng-container>

  <ng-template #selectedItemsTemplate>
    <div class="selected-items-template-label-wrapper">
      @if ($title()) {
        <div class="selected-items-template-label">{{ $title() }}</div>
      }
      @if ($filterActive()) {
        <span class="mr-3 ml-2 filter-indicator">
          <i [className]="IconKey.FilterActiveIndicator | icon"></i>
        </span>
      }
    </div>
  </ng-template>

  <ng-template #tooltipContent>
    <div class="p-2">
      @if ($customTitle()) {
        <div class="mb-3 font-bold" [innerHTML]="$customTitle()"></div>
      } @else if ($filterActive()) {
        <div class="mb-3 font-bold" [innerHTML]="'general.options.selectedOptions' | translate: { value: $title() }"></div>
      } @else {
        <div class="mb-3 font-bold" [innerHTML]="'general.options.noOptionsSelected' | translate: { value: $title() }"></div>
      }

      @if ($filterActive()) {
        @for (item of $selectedItems(); track item.key) {
          <li [style.padding-left.px]="$tooltipPaddings()[item.key]" class="mb-2 ml-1">
            {{ item.label }}
          </li>
        }
      }
    </div>
  </ng-template>

  <ng-template #placeholderTemplate>
    <div class="selected-items-template-placeholder">
      {{ $placeholder() || 'general.selectItem' | translate }}
    </div>
  </ng-template>
</div>
